export const enum AccessStatus {
  none = 1,
  pending = 2,
  hasAccess = 3
}
